module.exports = __webpack_public_path__ + "assets/img/5.3067c8ca.jpg";